import { Text } from '@pukka/ui-components';

import { getStatusCount } from './utils';

interface EWalletStatusSummaryProps {
  readonly statusCount: ReturnType<typeof getStatusCount>;
}

function EwalletStatusSummary({ statusCount }: EWalletStatusSummaryProps) {
  return (
    <div className="rounded-xl bg-white px-6 py-3">
      <Text variant="subtitle-2">Status</Text>
      {statusCount.active > 0 && (
        <Text variant="body-1" data-testid="active-count">
          ✅ &nbsp; Active: {statusCount.active} Outlet
        </Text>
      )}
      {statusCount.pending > 0 && (
        <Text variant="body-1" data-testid="pending-count">
          ⌛️ &nbsp; On Progress: {statusCount.pending} Outlet
        </Text>
      )}
      {statusCount.inactive > 0 && (
        <Text variant="body-1" data-testid="inactive-count">
          🟡 &nbsp; Not Registered: {statusCount.inactive} Outlet
        </Text>
      )}
      {statusCount.rejected > 0 && (
        <Text variant="body-1" data-testid="rejected-count">
          🚫 &nbsp; Rejected: {statusCount.rejected} Outlet (Contact us at{' '}
          <Text as="span" color="blue" className="underline" weight="bold">
            1500970
          </Text>
          )
        </Text>
      )}
    </div>
  );
}

export { EwalletStatusSummary };
